import { Component } from '@angular/core';
import { MotdComponent } from './motd/motd.component';

@Component({
  selector: 'mce-site',
  imports: [MotdComponent],
  templateUrl: './site.component.html',
  styleUrl: './site.component.scss'
})
export class SiteComponent {

}
